import { createContext } from 'react'
import type { UserProfile } from '../types/schema'

export interface AuthUser {
  uid: string
  email: string | null
  displayName: string | null
  photoURL: string | null
  phoneNumber?: string | null
  emailVerified?: boolean
  isAnonymous?: boolean
  providerId?: string | null
  getIdTokenResult?: (force?: boolean) => Promise<{ claims?: Record<string, unknown> }>
}

export interface AuthContextValue {
  user: AuthUser | null
  currentUser: AuthUser | null
  isAuthLoading: boolean
  wasLedgerDormant: boolean
  accountTier: string
  userProfile: UserProfile | null
  signInWithGoogle: () => Promise<void>
  /** Native-only. Sends the OTP and returns a verificationId that
   *  confirmPhoneCode consumes. Not available on web. */
  sendPhoneVerification: (phoneNumber: string) => Promise<string>
  /** Completes phone sign-in using the verificationId returned by
   *  sendPhoneVerification plus the OTP the user typed. */
  confirmPhoneCode: (verificationId: string, code: string) => Promise<void>
  signOutUser: (options?: { keepSession?: boolean; revocationMessage?: string; skipDraftGuards?: boolean }) => Promise<void>
  logout: (options?: { keepSession?: boolean; revocationMessage?: string; skipDraftGuards?: boolean }) => Promise<void>
  getInitialWorkspace: () => Promise<{ workspaceId: string; role: string } | null>
  isSessionLocked: boolean
  lockSession: () => void
  unlockSession: () => void
  sessionNotice?: string | null
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
